export const formScreenRegex = /^formScreen-\d+$/
